import React, { useEffect, useState } from 'react';
import { View, Modal, Animated, StyleSheet, Dimensions } from 'react-native';
import ModalContent from './ModalContent';
const AnimatedModal = ({ visible, onClose, handleConnection, triggerAction, rmData }) => {
    const opacity = new Animated.Value(0);
    const translateY = new Animated.Value(100);
    const windowX = Dimensions.get('window');
    const screenX = Dimensions.get('screen');
    const [dimensions, setDimensions] = useState({
        window: windowX,
        screen: screenX,
    });
    useEffect(() => {
        const subscription = Dimensions.addEventListener('change', ({ window, screen }) => {
            dimensions.window = window;
            dimensions.screen = screen;
            setDimensions({
                ...dimensions,
            });
        });
        return () => subscription?.remove();
    }, [dimensions]);
    const [screenWidth, setScreenWidth] = useState(dimensions.window.width);
    const handleAnimation = (toValue) => {
        Animated.parallel([
            Animated.timing(opacity, {
                toValue,
                duration: 300,
                useNativeDriver: true,
            }),
            Animated.timing(translateY, {
                toValue,
                duration: 300,
                useNativeDriver: true,
            }),
        ]).start();
    };
    useEffect(() => {
        if (visible) {
            handleAnimation(1);
        }
        else {
            handleAnimation(0);
        }
    }, [visible]);
    useEffect(() => {
        setScreenWidth(dimensions.window.width);
    }, [dimensions.window.width]);
    return (React.createElement(Modal, { transparent: true, visible: visible, animationType: "none" },
        React.createElement(View, { style: [styles.modalBackground, { paddingRight: screenWidth <= 1600 ? 0 : (screenWidth - 1600) / 2 }] },
            React.createElement(Animated.View, { style: { opacity, transform: [{ translateY }] } },
                React.createElement(ModalContent, { onClose: onClose, handleConnection: handleConnection, triggerAction: triggerAction, rmData: rmData })))));
};
export default AnimatedModal;
const styles = StyleSheet.create({
    modalBackground: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
});
